import { getEntity, isFetching, getError } from './_utils'

export const getPricing = getEntity('pricings')

export const fetchingPricing = (state, eventId) => isFetching(`/api/events/${eventId}/pricing`)(state)
export const getFetchingPricingError = (state, eventId) => getError(`/api/events/${eventId}/pricing`)(state)
